module.exports = __webpack_public_path__ + "media/images/common/signup-bebe2520c78f8d3b9036e44cd4df504e.gif";